// GENERATED FILE - DO NOT MODIFY
export enum PurchaseOrderSubContractType {
    Open = "O",
}

export let nameof = "PurchaseOrderSubContractType";
